import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { API } from '@/api'
import { Button, Checkbox, Input, message, Modal, Trans } from '@/components'
import { Instance } from '@/models/instance'

export function CreateSnapshotModal(props: {
  instance: Instance
  onClose: () => void
  snapshotOnSpaceBilling?: boolean
}) {
  const { instance, onClose, snapshotOnSpaceBilling = true } = props

  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [checked, setChecked] = useState(false)
  const { t } = useTranslation()

  const onOK = () => {
    API.createSnapshot({
      id: instance?.node?.id,
      request_vol_id: [],
      snapshot_release_node: checked,
      snapshot_required: true,
      snapshot_subject: name,
      status: 8,
    })
      .then((res) => {
        if (res.code === 0) {
          message.success(t('common.message.success'))
          onClose()
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Modal
      className="w-[800px]"
      open={!!instance}
      onClose={() => {
        if (!loading) {
          onClose()
        }
      }}
    >
      <Modal.Header>
        <Trans i18nKey="instance.snapshotModal.title">Take Snapshot</Trans>
      </Modal.Header>
      <Modal.Body>
        <div className="flex-row ">
          <div className="bg-panel-gray-100 rounded-lg p-4 flex-row mb-4">
            <div>
              <div className="text-[20px] leading-7 font-bold  text-primary">
                {instance.displayTitle}
              </div>
              {/* <div className="t-sb font-medium text-secondary">{instance.displayTitle}</div> */}
            </div>
            {/* <Divider className="my-3" />
        <div>
          <div>Estimated Size</div>
          <div>{instance.hardware.machine.cpuName}</div>
        </div>
        <Divider className="my-3" />
        <div>
          <div className=" text-btn-secondary t-sb cursor-pointer">
            How to optimize environment performance and costs?
          </div>
        </div> */}
          </div>
          <div className="bg-panel-gray-100 rounded-lg p-4 flex-row gap-y-3 mb-4">
            <ul className=" t-sm font-medium">
              <li>
                {/* · The instance will be <span className="text-red-500">paused</span> when taking a
                snapshot and will automatically resume once the snapshot is complete. */}
                ·{' '}
                <Trans
                  i18nKey={`instance.snapshotModal.tip1`}
                  components={[<span className="text-red-500">paused</span>]}
                >
                  The instance will be paused when taking a snapshot and will automatically resume
                  once the snapshot is complete.
                </Trans>
              </li>
              <li>
                ·{' '}
                <Trans i18nKey={`instance.snapshotModal.tip2`}>
                  Taking a snapshot will not incur additional charges, but the instance cannot be
                  released during this process.
                </Trans>
              </li>
              <li>
                ·{' '}
                {snapshotOnSpaceBilling ? (
                  <Trans i18nKey={`instance.snapshotModal.tip3`}>
                    The snapshot file will be stored in your Space. Please ensure you have a
                    sufficient storage quota to accommodate the snapshot.
                  </Trans>
                ) : (
                  <Trans i18nKey={`instance.snapshotModal.tip3TimeBased`}>
                    The snapshot will be billed independently based on its stored size and storage
                    duration.
                  </Trans>
                )}
              </li>
            </ul>
          </div>

          <div className="w-full t-lg text-primary">
            <div className="mb-2 text-with-star">
              <Trans i18nKey="instance.snapshotModal.form.name">Name</Trans>
            </div>
            <div className="w-full t-lg text-primary mb-2">
              <Input
                placeholder={t('instance.snapshotModal.form.namePlaceholder')}
                value={name}
                disabled={loading}
                maxLength={30}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="flex gap-1 items-center ">
              {!instance.isSubscription && (
                <>
                  <Checkbox
                    checked={checked}
                    onChange={(checked) => {
                      setChecked(checked)
                    }}
                    className="self-start"
                  />
                  <div
                    className="t-sm font-medium text-secondary cursor-pointer"
                    onClick={() => setChecked(!checked)}
                  >
                    <Trans i18nKey="instance.snapshotModal.form.checkbox">
                      The instance will be automatically released after the process is completed.
                    </Trans>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="outline"
          onClick={() => {
            if (!loading) {
              onClose()
            }
          }}
        >
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button type="secondary" disabled={loading || name?.length <= 0} onClick={onOK}>
          <Trans i18nKey="instance.snapshotModal.takeSnapshotBtn">Take Snapshot</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
